export default "__VITE_ASSET__DJc_Edya__"